var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLetterIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "14px",
    viewBox: "0 0 18 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    className: "hover-stroke",
    id: "Sign-In",
    transform: "translate(-849.000000, -537.000000)",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(850.000000, 538.500200)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-1",
    points: "0 10.9912 15.948 10.9912 15.948 0.000199999999 0 0.000199999999"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-3",
    points: "0.2156 0.392 7.9686 5.871 15.9486 0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterIc);
export default __webpack_public_path__ + "static/media/letter-ic.b4198f1122e4c3ec9fda8a0ef5e3315d.svg";
export { ForwardRef as ReactComponent };